import { LenderProfile, FinanceProgram } from '@trnsact/trnsact-shared-types';

export function rejectDisabledFinancePrograms(financePrograms: FinanceProgram[], lenderProfiles: LenderProfile[]) {
  return financePrograms.filter(fp => {
    const financeProgramToLenderProfile = fp.financeProgramToLenderProfiles?.find(fptlp =>
      lenderProfiles.some(lp => lp.id === fptlp?.lenderProfileId)
    );
    return !!financeProgramToLenderProfile && !financeProgramToLenderProfile.isDisabled;
  });
}
